
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class CostService {
    constructor(private http: HttpClient) { }

    //#region Obtener Costos y Privisiones
    getCostsByRequirementId(idRequirement) {
        return this.http.get(`${environment.apiUrl}/trackvision/requirement/${idRequirement}/costs`,
            {
                headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
            }
        );
    }
    //#endregion

    //#region Crear un costo al requerimiento
    createCostByRequirementId(idRequirement, body) {

        return this.http.post(`${environment.apiUrl}/trackvision/requirement/${idRequirement}/cost/create`, body,
            {
                headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
            }
        );
    }
    //#endregion

    //#region Actualizar un costo al requerimiento
    updateCost(body) {

        return this.http.post(`${environment.apiUrl}/trackvision/requirement/cost/update`, body,
            {
                headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
            }
        );
    }
    //#endregion

    //#region Eliminar Colaborador suscrito al requerimiento
    deleteCost(body) {
        return this.http.post(`${environment.apiUrl}/trackvision/requirement/cost/delete`, body,
            {
                headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
            }
        );
    }
    //#endregion

    async deleteFile(body:any):Promise<any>{
        return this.http.post(`${environment.apiUrl}/trackvision/requirement/cost/deletefile`, body,
        {
            headers: new HttpHeaders().set("Token", localStorage.getItem("access_token") || ""),
        }
      ).toPromise();
    }

}